import isIE from 'services/isIE';

const ie11VerticalFlexCenterFix = height =>
	isIE()
		? `
&::before {
	display: block;
	content: '';
	${height}
}`
		: '';

export default ie11VerticalFlexCenterFix;
